
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import CandidateCreateForm, {
  StructCandidateData
} from "@/lib/form/candidate/CandidateCreateForm";
import Candidate, {
  CandidateMCreateParamsJob,
  CandidateMCreateParseParams,
  CandidateParam
} from "@/lib/model/exam/candidate";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import gateway from "@/lib/request/gateway";
import ModalTitle from "@/lib/model/exam/modal-title";
import Auth from "@/lib/common/auth";
import track from "@/lib/common/track";
import Job from "@/lib/job/job";
class ExamItem {
  id = 0;
  name = "";
  remark = "";
}

@Component({
  components: {
    ModalHeader
  }
})
export default class AddMoreCandidateModal extends Vue {
  name = "add-more-candidate";
  CandidateMCreateParamsJob = new CandidateMCreateParamsJob();
  @Prop() mobileMessageTemplateId!: number;
  @Prop() emailMessageTemplateId!: number;
  @Prop() jobId!: number;

  modalTitle: ModalTitle = new ModalTitle();
  currentData: any = [];
  tableHeaders: string[] = [""];
  isDisabled = true;
  canSelected = true;
  showSelectError = false;
  examFiltedAll: ExamItem[] = new Array<ExamItem>();
  selectedPaperId = 0;
  examSelected: any = "";
  showNoCandidateError = false;

  get okList() {
    return this.currentData.filter((e: any) => e.isOk === true);
  }

  get errorList() {
    return this.currentData.filter((e: any) => e.isOk === false);
  }

  get uploadUrl() {
    // return _.trim(config.apiUrl) + "/aiExam/candidate/mCreate";
    return "/";
  }

  get token() {
    return Auth.token;
  }

  @Watch("okList")
  onOkListChange() {
    if (this.okList.length > 0) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  @Emit("cancel")
  handleClose() {
    //
  }

  mounted() {
    //
  }

  importMCandidate() {
    if (this.okList.length > 0) {
      // this.showNoCandidateError = false;
      this.CandidateMCreateParamsJob.whiteUserList = [];
      this.okList.forEach((item: any, index: number) => {
        const params = new StructCandidateData();
        params.showName = item.showName;
        params.phone = item.phone;
        params.email = item.email;
        this.CandidateMCreateParamsJob.whiteUserList.push(params);
      });
      this.CandidateMCreateParamsJob.jobId = String(this.jobId);
      this.CandidateMCreateParamsJob.mobileMessageTemplateId = this.mobileMessageTemplateId;
      this.CandidateMCreateParamsJob.emailMessageTemplateId = this.emailMessageTemplateId;
      Job.createWhiteM(this.CandidateMCreateParamsJob).then(res => {
        if (res) {
          this.$message.success("导入成功");
          this.$emit("success");
        } else {
          // this.$message.error(res.message);
        }
      });
    } else {
      this.$message.error("当前没有可添加的候选人");
      // this.showNoCandidateError = true;
    }
  }

  importMCancel() {
    this.handleClose();
  }

  downloadExel() {
    const a = document.createElement("a");
    a.href =
      "https://oss.hina.com/aiExam/exportExcel/2022/10/28/673077a07c934fa38a6d97d9891c2289/%E6%89%B9%E9%87%8F%E5%80%99%E9%80%89%E4%BA%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";
    a.setAttribute("download", "批量添加候选人模板");
    a.click();
  }

  ossUrl = "";
  beforeUpload(file: File) {
    let isExcel = false;
    const ext = file.name.toLowerCase().split(".");
    if (ext[ext.length - 1] == "xlsx" || ext[ext.length - 1] == "xls") {
      isExcel = true;
    }
    if (!isExcel) {
      this.$message.error("上传文件只能是 xls/xlsx 格式!");
      return;
    }

    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + postRes.dir;
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
            this.ossUrl = res.url;
          })
          .then(() => {
            Job.parseWhiteM({ ossUrl: this.ossUrl, jobId: this.jobId }).then(
              res => {
                if (res.code === 0) {
                  if (res.data.count === 0) {
                    this.$message.warning("上传文件内容为空");
                  }
                  this.currentData = [];
                  this.currentData = res.data.list;
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          })
          .catch((err: any) => {
            return isExcel;
          })
          .finally(() => {
            return isExcel;
          });
      }
    });
  }

  uploadSuccess(e: any) {
    console.log("uploadSuccess e: ", e);
  }
  send(row: any) {
    Job.sendWhite({
      jobId: this.jobId,
      mobileMessageTemplateId: this.mobileMessageTemplateId,
      emailMessageTemplateId: this.emailMessageTemplateId,
      sendMobile: true,
      sendEmile: true
    }).then(res => {
      //
    });
  }
  del(scope: any) {
    this.currentData.splice(scope.$index, 1);
  }
}
